import { Template } from 'meteor/templating';
import { ReactiveVar } from 'meteor/reactive-var';
import { Session } from 'meteor/session';
import { Tracker } from 'meteor/tracker';

import './audio_entry_gate_lecture.html';
import './audio_entry_gate_lecture.css';
import { Projets } from '../../../../imports/collections.js';
import { normalise_ecran_demarrage_projet } from '../../../../imports/projet_ecran_demarrage_settings.js';

const gAudioEntryGateVisible = new ReactiveVar (true);
const gAudioEntryGateClosing = new ReactiveVar (false);
let gAudioEntryGateHideTimer = null;
const AUDIO_ENTRY_GATE_LOOP_EPSILON_S = 0.05;
const gAudioEntryGatePlatformMobile = detecte_plateforme_mobile_audio_entry_gate ();

function detecte_plateforme_mobile_audio_entry_gate ()
  {
    if (typeof navigator !== 'undefined')
      {
        if (navigator.userAgentData && navigator.userAgentData.mobile === true)
          return true;
        const tUserAgent = typeof navigator.userAgent === 'string' ? navigator.userAgent : '';
        if (/\b(Android|iPhone|iPad|iPod|IEMobile|Windows Phone|BlackBerry|BB10|Mobile)\b/i.test (tUserAgent))
          return true;
        if (/\bMacintosh\b/i.test (tUserAgent) && navigator.maxTouchPoints > 1)
          return true;
      }
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function')
      {
        try
          {
            return window.matchMedia ('(hover: none) and (pointer: coarse)').matches;
          }
        catch (e) {}
      }
    return false;
  }

function projet_courant_audio_entry_gate ()
  {
    const tProjetId = Session.get ('projet_id');
    return tProjetId ? Projets.findOne (tProjetId) : null;
  }

function ecran_demarrage_audio_entry_gate ()
  {
    const tProjet = projet_courant_audio_entry_gate ();
    return normalise_ecran_demarrage_projet (tProjet && tProjet.ecran_demarrage);
  }

function ecran_demarrage_affichable_audio_entry_gate ()
  {
    const tProjet = projet_courant_audio_entry_gate ();
    if (!tProjet) return false;
    const tReglages = normalise_ecran_demarrage_projet (tProjet.ecran_demarrage);
    if (gAudioEntryGatePlatformMobile)
      return tReglages.afficher_mobile !== false;
    return tReglages.afficher_desktop !== false;
  }

function video_audio_entry_gate ()
  {
    if (typeof document === 'undefined') return null;
    return document.querySelector ('.js_audio_entry_gate_video');
  }

function lance_video_audio_entry_gate ()
  {
    const tVideo = video_audio_entry_gate ();
    if (!tVideo) return;
    tVideo.muted = true;
    tVideo.playsInline = true;
    installe_boucle_video_audio_entry_gate (tVideo);
    const tLecture = tVideo.play ();
    if (tLecture && typeof tLecture.catch === 'function')
      tLecture.catch (() => {});
  }

function reglages_boucle_video_audio_entry_gate (pVideo)
  {
    if (!pVideo || !pVideo.dataset || pVideo.dataset.loopEnabled !== '1') return null;
    let tStart = Number (pVideo.dataset.loopStart);
    let tEnd = Number (pVideo.dataset.loopEnd);
    const tDuree = Number (pVideo.duration);
    if (!Number.isFinite (tStart) || tStart < 0) tStart = 0;
    if (Number.isFinite (tDuree) && tDuree > 0)
      tStart = Math.min (tStart, Math.max (0, tDuree - AUDIO_ENTRY_GATE_LOOP_EPSILON_S));
    if (!Number.isFinite (tEnd) || tEnd <= tStart)
      tEnd = Number.isFinite (tDuree) && tDuree > 0 ? tDuree : null;
    if (Number.isFinite (tDuree) && tDuree > 0 && tEnd !== null)
      tEnd = Math.min (tEnd, tDuree);
    if (!(tEnd > tStart)) return null;
    return {start : tStart, end : tEnd};
  }

function applique_boucle_video_audio_entry_gate (pVideo, pForce = false)
  {
    const tReglages = reglages_boucle_video_audio_entry_gate (pVideo);
    if (!tReglages) return;
    if (!pForce && Number (pVideo.currentTime) < tReglages.end - AUDIO_ENTRY_GATE_LOOP_EPSILON_S) return;
    const tRelancer = !pVideo.paused || pForce;
    try { pVideo.currentTime = tReglages.start; } catch (e) {}
    if (tRelancer)
      {
        const tLecture = pVideo.play ();
        if (tLecture && typeof tLecture.catch === 'function')
          tLecture.catch (() => {});
      }
  }

function installe_boucle_video_audio_entry_gate (pVideo)
  {
    if (!pVideo || pVideo._audioEntryGateLoopInstalled) return;
    pVideo._audioEntryGateLoopInstalled = true;
    pVideo.addEventListener ('timeupdate', () => applique_boucle_video_audio_entry_gate (pVideo));
    pVideo.addEventListener ('ended', () => applique_boucle_video_audio_entry_gate (pVideo, true));
  }

function hide_audio_entry_gate ()
  {
    if (gAudioEntryGateHideTimer)
      {
        clearTimeout (gAudioEntryGateHideTimer);
        gAudioEntryGateHideTimer = null;
      }
    gAudioEntryGateClosing.set (false);
    gAudioEntryGateVisible.set (false);
  }

// Vrai tant que l'écran d'entrée couvre la scène et attend l'appui du joueur (non réactif) :
// les animations d'entrée de la première scène sont alors tenues à leur départ.
export function audio_entry_gate_en_attente ()
  {
    return Tracker.nonreactive (() =>
      gAudioEntryGateVisible.get ()
      && !gAudioEntryGateClosing.get ()
      && ecran_demarrage_affichable_audio_entry_gate ());
  }

function active_entree_audio ()
  {
    if (!ecran_demarrage_affichable_audio_entry_gate ()) return;
    if (!gAudioEntryGateVisible.get () || gAudioEntryGateClosing.get ()) return;
    const tReglages = ecran_demarrage_audio_entry_gate ();
    const tFadeoutMs = Math.max (0, Number (tReglages.fadeout_ms) || 0);
    gAudioEntryGateClosing.set (true);
    window.dispatchEvent (new CustomEvent ('diffusion:audio-entry-activate'));
    if (tFadeoutMs <= 0)
      {
        hide_audio_entry_gate ();
        return;
      }
    gAudioEntryGateHideTimer = setTimeout (hide_audio_entry_gate, tFadeoutMs);
  }

Template.diffusionAudioEntryGate.helpers (
  {
    visible ()
      {
        return gAudioEntryGateVisible.get () && ecran_demarrage_affichable_audio_entry_gate ();
      },

    closingClass ()
      {
        return gAudioEntryGateClosing.get () ? 'is-closing' : '';
      },

    gateStyle ()
      {
        const tFadeoutMs = Math.max (0, Number (ecran_demarrage_audio_entry_gate ().fadeout_ms) || 0);
        return `--audio-entry-gate-fadeout-ms: ${tFadeoutMs}ms;`;
      },

    imageUrl ()
      {
        const tReglages = ecran_demarrage_audio_entry_gate ();
        return tReglages.media_type === 'image'
          ? (tReglages.media_url || tReglages.image_url || null)
          : (tReglages.image_url || null);
      },

    videoUrl ()
      {
        const tReglages = ecran_demarrage_audio_entry_gate ();
        return tReglages.media_type === 'video'
          ? (tReglages.media_url || tReglages.video_url || null)
          : null;
      },

    videoLoopEnabledAttr ()
      {
        return ecran_demarrage_audio_entry_gate ().loop ? '1' : '0';
      },

    videoLoopStartAttr ()
      {
        return String (ecran_demarrage_audio_entry_gate ().loop_start_s || 0);
      },

    videoLoopEndAttr ()
      {
        const tValeur = ecran_demarrage_audio_entry_gate ().loop_end_s;
        return tValeur === null ? '' : String (tValeur);
      },
  });

Template.diffusionAudioEntryGate.onRendered (function ()
  {
    this.autorun (() =>
      {
        const tReglages = ecran_demarrage_audio_entry_gate ();
        if (
          gAudioEntryGateVisible.get ()
          && ecran_demarrage_affichable_audio_entry_gate ()
          && tReglages.media_type === 'video'
          && tReglages.media_url
        )
          Tracker.afterFlush (lance_video_audio_entry_gate);
      });
  });

Template.diffusionAudioEntryGate.events (
  {
    'pointerdown .js_audio_entry_gate' (pEvent)
      {
        pEvent.preventDefault ();
        active_entree_audio ();
      },

    'click .js_audio_entry_gate' (pEvent)
      {
        pEvent.preventDefault ();
        active_entree_audio ();
      },
  });
